import { render, staticRenderFns } from "./CategoryBatchEdit.vue?vue&type=template&id=745ac9ab&scoped=true&"
import script from "./CategoryBatchEdit.vue?vue&type=script&lang=js&"
export * from "./CategoryBatchEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745ac9ab",
  null
  
)

export default component.exports